import React from 'react';

import { localStorageSet, localStorageGet } from '../../utils/local-storage';

export const LS_KEY = 'trowe_compare_funds';

export const setDefaultFund = (fund) => localStorageSet(LS_KEY, [fund]);

const remNull = (arr) => {
    if (arr && arr.length) {
        return arr.filter((obj) => obj);
    }
    return [];
};

export default class WithCompareState extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            funds: remNull(localStorageGet(LS_KEY)) || []
        };
    }

    componentDidUpdate() {
        localStorageSet(LS_KEY, this.state.funds);
    }

    add = (ticker) => {
        if (this.state.funds.includes(ticker)) return;
        this.setState((prevState) => ({ funds: [...prevState.funds, ticker] }));
    };

    remove = (ticker) => {
        this.setState((prevState) => ({
            funds: prevState.funds.filter((t) => t !== ticker)
        }));
    };

    removeAll = () => {
        this.setState({ funds: [] });
    };

    toggle = (ticker) => {
        if (this.state.funds.includes(ticker)) {
            this.remove(ticker);
        } else {
            this.add(ticker);
        }
    };

    render() {
        if (typeof this.props.children === 'function') {
            const api = {
                addFund: this.add,
                removeFund: this.remove,
                removeAllFunds: this.removeAll,
                toggleFund: this.toggle
            };
            return this.props.children(this.state.funds, api);
        }
        return false;
    }
}
